import { defineComponent } from 'vue';
import useNavigation from '@/composables/navigation';
export default defineComponent({
    setup() {
        const { isMenuOpen, toggleMenu } = useNavigation();
        return {
            isMenuOpen,
            toggleMenu,
        };
    },
});
